export default __webpack_public_path__ + "static/media/information-filled.2952440e.svg";